import useIsFerry from "./useIsFerry";
import useLocale from "@Hooks/selector/useLocale";
import useGetByFerrySupportedLocale from "./useGetByFerrySupportedLocale";
import useForm from "@Form/hooks/useForm";
import {LocaleType} from "@/types/Locale.type";

/**
 * Converts locale to ferry supported variant
 * @returns {{isFerry: (boolean|*), transportType: *, locale: (string|*)}}
 */
export default function useFerrySupportedLocale() {
    const isFerry = useIsFerry()
    const locale = useLocale() as LocaleType
    const getByFerrySupportedLocale = useGetByFerrySupportedLocale()
    const supportedLocale = isFerry ? getByFerrySupportedLocale : locale
    const transportType: string = useForm('transportTypeRouteTranslation')

    return {
        isFerry,
        locale: supportedLocale,
        transportType,
    }
}